import React from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import classNames from "classnames";

import "./styles.scss";

import Body from "./Body";

const Main = ({ children, className, body }) => {
  return (
    <Container
      fluid
      className={classNames(
        "mydpd-main d-flex flex-column h-100 p-0",
        className
      )}
    >
      {body ? <Body>{children}</Body> : children}
    </Container>
  );
};

Main.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  /**
   * When this prop is set, it creates a Card with a Card.Body inside
   * passing the children directly to it
   */
  body: PropTypes.bool,
};

export default Main;
